export var ParseResult;
(function (ParseResult) {
    let Type;
    (function (Type) {
        Type["Success"] = "SUCCESS";
        Type["Failure"] = "FAILURE";
    })(Type = ParseResult.Type || (ParseResult.Type = {}));
    function success(tree, root) {
        return { tree, root, type: "SUCCESS" };
    }
    ParseResult.success = success;
    function failure(error) {
        return { error, type: "FAILURE" };
    }
    ParseResult.failure = failure;
})(ParseResult || (ParseResult = {}));
